export default __STORYBOOKCHANNELS__;
const { Channel } = __STORYBOOKCHANNELS__;
export { Channel };